<template>
  <div class="section-main__warp" style="margin-top: 0px;">
    <div class="fuel-related">
      <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
        @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        <template slot="menuLeft">
          <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
            新增
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-edit-outline" @click="handleUdp(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
        </template>
      </ioc-table>
      <el-dialog :title="dialogTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
        width="35%">
        <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
          <el-form-item label="燃料名称" prop="fuelName">
            <el-input v-model="addForm.fuelName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="燃料单位" prop="fuelUnit">
            <el-select v-model="addForm.fuelUnit" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in fuelUnitArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="低位发热量" prop="lowerHeating">
            <el-input v-model="addForm.lowerHeating" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="单位热值含碳量" prop="carbonUnitHeating">
            <el-input v-model="addForm.carbonUnitHeating" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="碳氧化率" prop="oxidationRate">
            <el-input v-model="addForm.oxidationRate" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="分子量" prop="molecularWeight">
            <el-input v-model="addForm.molecularWeight" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="fuelRemark">
            <el-input v-model="addForm.fuelRemark" placeholder="请输入" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
          <el-button @click="addCancel('addForm')">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/fuelRelated";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        fuelName: [{ required: true, message: '请输入燃料名称', trigger: ['blur', 'change'] }],
        fuelUnit: [{ required: true, message: '请选择燃料单位', trigger: ['blur', 'change'] }],
        lowerHeating: [{ required: true, message: '请输入低位发热量', trigger: ['blur', 'change'] }],
        carbonUnitHeating: [{ required: true, message: '请输入单位热值含碳量', trigger: ['blur', 'change'] }],
        oxidationRate: [{ required: true, message: '请输入碳氧化率', trigger: ['blur', 'change'] }],
        molecularWeight: [{ required: true, message: '请输入分子量', trigger: ['blur', 'change'] }],
      },
      dialogTitle: '',
      addVisible: false,
      modalClose: false,
      addForm: {
        fuelId: null,
        fuelName: '',
        fuelUnit: '',
        lowerHeating: '',
        carbonUnitHeating: '',
        oxidationRate: '',
        molecularWeight: '',
        fuelRemark: ''
      },
      fuelUnitArr: [{ 'label': 'T', 'value': 'T' }, { 'label': '10^4Nm³', 'value': '10^4Nm³' }]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        fuelName: this.searchForm.fuelName
      };
      this.$fetch(api.fuelRelated.queryFuelList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增'
      this.addForm.fuelId = ''
      this.addForm.fuelName = ''
      this.addForm.fuelUnit = ''
      this.addForm.lowerHeating = ''
      this.addForm.carbonUnitHeating = ''
      this.addForm.oxidationRate = ''
      this.addForm.molecularWeight = '44/12'
      this.addForm.fuelRemark = ''
      this.addVisible = true;
    },
    addCancel(formName) {
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.fuelId) {
            let params = {
              fuelId: this.addForm.fuelId,
              fuelName: this.addForm.fuelName,
              fuelUnit: this.addForm.fuelUnit,
              lowerHeating: this.addForm.lowerHeating,
              carbonUnitHeating: this.addForm.carbonUnitHeating,
              oxidationRate: this.addForm.oxidationRate,
              molecularWeight: this.addForm.molecularWeight,
              fuelRemark: this.addForm.fuelRemark
            }
            this.$fetch(api.fuelRelated.updateFuelList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              fuelName: this.addForm.fuelName,
              fuelUnit: this.addForm.fuelUnit,
              lowerHeating: this.addForm.lowerHeating,
              carbonUnitHeating: this.addForm.carbonUnitHeating,
              oxidationRate: this.addForm.oxidationRate,
              molecularWeight: this.addForm.molecularWeight,
              fuelRemark: this.addForm.fuelRemark
            }
            this.$fetch(api.fuelRelated.addFuelList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    // 修改
    handleUdp(row) {
      this.dialogTitle = '修改'
      this.addForm.fuelId = row.fuelId
      this.addForm.fuelName = row.fuelName
      this.addForm.fuelUnit = row.fuelUnit
      this.addForm.lowerHeating = row.lowerHeating
      this.addForm.carbonUnitHeating = row.carbonUnitHeating
      this.addForm.oxidationRate = row.oxidationRate
      this.addForm.molecularWeight = row.molecularWeight
      this.addForm.fuelRemark = row.fuelRemark
      this.addVisible = true;
    },
    // 删除
    handleDel(row) {
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bms/carbon/emission/fuel/del/' + row.fuelId + '.json').then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fuel-related {
  width: 100%;
  height: calc(100vh - 115px);
}
</style>